
var isMobile = new Object();
isMobile.Android = function () {
	return navigator.userAgent.match(/Android/i);
};

isMobile.BlackBerry = function () {
	return navigator.userAgent.match(/BlackBerry/i);
};
isMobile.iOS = function () {
	return navigator.userAgent.match(/iPhone|iPad|iPod/i);
};

isMobile.iPad = function () {
	return navigator.userAgent.match(/iPad/i);
};
isMobile.Opera = function () {
	return navigator.userAgent.match(/Opera Mini/i);
};
isMobile.Windows = function () {
	return navigator.userAgent.match(/IEMobile/i);
};

isMobile.Firefox = function () {
	return navigator.userAgent.match(/Firefox/gi);
};
isMobile.InternetExplorer = function () {
	return navigator.userAgent.match(/MSIE/gi);
};
isMobile.Opera = function () {
	return navigator.userAgent.match(/Opera/gi);
};
isMobile.Safari = function () {
	return navigator.userAgent.match(/Safari/gi);
};
isMobile.any = function () {
	return (
		isMobile.Android() ||
		isMobile.BlackBerry() ||
		isMobile.iOS() ||
		isMobile.Opera() ||
		isMobile.Windows()
	);
};
if (isMobile.any() && isMobile.iPad() == null) {
	//return;
}

var ua = window.navigator.userAgent;
var is_ie = /MSIE|Trident/.test(ua);

/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

var winWT;
var winHT;

/* window.onbeforeunload = function () {
	window.scrollTo(0, 0);
} */

$(document).ready(function () {
	

	var disableScrolling = function(){
		var x=window.scrollX;
		var y=window.scrollY;
		window.onscroll=function(){window.scrollTo(x, y);};
	}
	var enableScrolling = function(){
		window.onscroll=function(){};
	}
	function onResize(){
		if(isMobile.any() && $("input").is(":focus")==true){
			return;
		}
		winWT = $(window).innerWidth();
		winHT = $(window).innerHeight();
		//$("section").css({minHeight:winHT});
	}
	$(window).resize(onResize)
	onResize();

	if(winWT < 601){
		// Listen for orientation changes
		function onOrientationChange() {
			if (window.orientation == 90 || window.orientation == -90) {
				$(".rotate-msg").css("display", "block");
			} else {
				$(".rotate-msg").css("display", "none");
			}
		}
		window.addEventListener("orientationchange", onOrientationChange, false);
		onOrientationChange();
	}
	
	TweenMax.set(".sidenav ul>li", { opacity: 0, x:-20, ease:Power2.easeInOut });
	TweenMax.to(".sidenav ul", 0.1, {height:"0%",  ease:Power0.easeNone});

	$('.menu').click(function (e) {
		$(this).toggleClass("toggle");
		if ($('.menu').hasClass("toggle")) {
			disableScrolling();
			$(".sidenav").css("display","block");
			TweenMax.to(".navOverLay", 0.2, {width:"100%",  ease:Power0.easeNone})
			TweenMax.to(".sidenav ul", 0.5, {height:"auto",  ease:Power0.easeNone})
			TweenMax.staggerTo(".sidenav ul>li", 0.5, {opacity:1, x:0, ease:Power2.easeInOut}, 0.1);
			//$(".menu").css({"top":"70px", "bottom":"auto"});
			
		} else {
			enableScrolling();
			$(".sidenav").css("display","none");
			TweenMax.to(".navOverLay", 0.2, {width:"0%",  ease:Power0.easeNone})
			TweenMax.set(".sidenav ul>li", { opacity: 0, x:-20, ease:Power2.easeInOut })
			TweenMax.to(".sidenav ul", 0.5, {height:"0%",  ease:Power0.easeNone});
			//$(".menu").css({"top":"auto", "bottom":"0px"});
		}
	});
	$('.sidenav ul li a').click(function () {
		$('.menu').trigger('click');
	})

	var navPosition = "down";
	function headerWipe(){
		if (winWT < 1024){
			if ($(this).scrollTop() > 10) {
				//TweenMax.set(".scroll-down", { opacity: 0 });
			} else {
				//TweenMax.set(".scroll-down", { opacity: 1 });
			}
		}
		else{
			if($('.menu').hasClass("toggle")){
				return;
			}
			if ($(this).scrollTop() > 10 && navPosition == "down") {
				navPosition = "up";
				$("header").addClass("sticky");
				$("nav").addClass("sticky");
				console.log('dsfdsf');
			}
			else if($(this).scrollTop() < 10 && navPosition == "up"){
				navPosition = "down";
				$("header").removeClass("sticky");
				$("nav").removeClass("sticky");
			}
		}
	}
	headerWipe();
	
	$(window).bind('scroll', function () {
		headerWipe();
	});

	$('#benefit-slider').slick({
		dots: false,
		arrows: true,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1, 
		responsive: [
		{
			breakpoint: 767,
			settings: {
				dots: true,
				arrows: false
			}
		}] 
	});

	$('#home-slider').slick({
		dots: true,
		arrows: false,
		infinite: true,
		autoplay: true,
  		autoplaySpeed: 4000,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1
	});

	/********** L O A D   P A G E   E X T E R N L L Y   C H A P T E R   04 ***********/
	
	//$('#chapter_four_tabs_det').load("dummy.html");
	var isFirstClick = true;
	$('.dropdown-menu li a').each(function(){
		$(this).bind('click', function(){
			var currPageName = $(this).attr('page_name');
			TweenMax.to('#chapter_four_tabs_det', 0.6, {opacity:0, ease:Cubic.easeOut, onComplete:function(){				
				$('#chapter_four_tabs_det').load(currPageName, function(){
					$('.accordion-row').beefup({
						openSingle: true,
						scroll: true,
						scrollOffset: -90,
					});
					TweenMax.to('#chapter_four_tabs_det', 0.6, {opacity:1, ease:Cubic.easeOut, onComplete:function(){
					}});
				});
			}})
			$('.dropdown-menu li a').removeClass('active');
			$(this).addClass('active');
			if(isFirstClick == false){
				$('html, body').animate({
					scrollTop: $('#single_chapter').offset().top
				  }, 1200, function() {
					headerWipe();
				});
			}
			isFirstClick = false;
		});
	});

	var searchArr = window.location.search.split('=');

	if(searchArr.length < 2){
		$($('.dropdown-menu li a')[0]).trigger('click');
	}else{
		var searchTab = $('#tab-'+searchArr[1]);
		if(searchTab.length <= 0){
			$($('.dropdown-menu li a')[0]).trigger('click');
		}else{
			isFirstClick = false;
			$('#tab-'+searchArr[1]).trigger('click');
		}
	}


	$(".btntext a").on('click', function(event) {
		if (this.hash !== "") {
		  var hash = this.hash;
		  $('html, body').animate({
			scrollTop: $(hash).offset().top
		  }, 2000, function() {
			window.location.hash = hash;
		  });
		  return false;
		} 
	  });


	$('.accordion-row').beefup({
		openSingle: true,
		scroll: true,
		scrollOffset: -90,
	});

	
	$('.ae-select-content').text($('.dropdown-menu > li.selected').text());
	var newOptions = $('.dropdown-menu > li');
	newOptions.click(function() {
		$('.ae-select-content').text($(this).text());
		$('.dropdown-menu > li').removeClass('selected');
		$(this).addClass('selected');
	});

	var aeDropdown = $('.ae-dropdown');
	aeDropdown.click(function() {
		$('.dropdown-menu').toggleClass('ae-hide');
	});
	
	function setSlentNavPin(){
		var a = $(".chapter-context").innerHeight();
		var scrollMagicController =  new ScrollMagic.Controller();
		var scene1 = new ScrollMagic.Scene({
			triggerElement: "#chapter_four_tabs_det",
			 duration: function(){
				return $("#chapter_four_tabs_det").innerHeight()-420;
			 }, 
			triggerHook: 0.08, // don't trigger until #pinned-trigger1 hits the top of the viewport
			reverse: true // allows the effect to trigger when scrolled in the reverse direction
		})
		//.addIndicators({})
		.setPin("#setNavPin") // the element we want to pin
		.addTo(scrollMagicController);
	}
	

	if(!isMobile.any()){
		setSlentNavPin();
	}



	
});
$(document).ready(function(){
    function setupQuiz(){
        var questionPanel = $(".question-panel");
        questionPanel.each(function(i){
            var radioLable = $(this).find(".radio-label");
            var inputs = $(this).find(".radio-label input");
            inputs.each(function(ia){
                var input = $(this);
                var nameStr = "group_"+i;
                input.attr("name", nameStr);
            });
            inputs.change(function(e) {
                inputs.parent().removeClass("correct");
                inputs.parent().removeClass("wrong");
                inputs.parent().removeClass("checked");
                $(this).parent().addClass("checked");
            });          
        })
        var quizSubmitBtn = $(".quizSubmitBtn");
        var score = 0;
        quizSubmitBtn.bind("click", function(){
            var isAnsAllquestion = true;
            for (var i = 0; i < questionPanel.length; i++) {
                var question = $(questionPanel[i]);
                var inputs = question.find(".radio-label input");
                var checked = inputs.is(':checked');
                if(checked==false){
                    var body = $("html, body");
                    body.stop().animate({scrollTop:(question.offset().top-100)}, 500, 'swing', function() { 
                        question.removeClass("blinker");
                        setTimeout(function(){
                            question.addClass("blinker");
                        }, 60)
                    });
                    isAnsAllquestion = false;
                    break;
                }                
            }
            if(isAnsAllquestion){
                score = 0;
                for (var i = 0; i < questionPanel.length; i++) {
                    var question = $(questionPanel[i]);
                    question.css({pointerEvents:"none"})
                    var inputs = question.find(".radio-label input");
                    inputs.each(function(){
                        var input = $(this);
                        var checked = input.is(':checked');
                        input.parent().removeClass("correct");
                        input.parent().removeClass("wrong");
                        if(input.data().ans){
                            input.parent().addClass("correct")
                        }
                        if(checked){
                            if(input.data().ans){
                                // input.parent().addClass("correct")
                                score++;
                            }else{
                                input.parent().addClass("wrong")
                            }
                        }
                        
                    })
                    
                }
                TweenMax.set(".score-panel", {display:"block", opacity:0, scale:0.5});
                TweenMax.to(".button-main", 0.3, {opacity:0, scale:0.5, ease:Cubic.easeIn, onComplete:function(){
                    TweenMax.to(".score-panel", 0.3, {opacity:1, scale:1, ease:Cubic.easeOut, onComplete:function(){
                    
                    }})
                }})
                $(".score-panel .score").html(score+"/"+questionPanel.length);
            }else{

            }
            
        })
        $('.blurb-contest').click(function() {
            $(".test-panel").slideDown();
        });
    }
    setupQuiz();  

})